module.exports = __webpack_public_path__ + "static/img/v2_t1n47c.7e55a9da.png";